<!-- TBreadcrumb element based on scale css
current Scale breadcrumb component don't support custom click event for links it reloads the page
-->
<template>
  <div class="t-page-breadcrumbs">
    <ol>
      <li
        v-for="(breadcrumb, i) in currentBreadcrumb.breadcrumb"
        :key="breadcrumb.title"
        class="t-page-breadcrumbs--item"
      >
        <span v-if="i !== 0" class="t-page-breadcrumbs--seperator">
          <slot name="breadcrumbs-seperator">
            <scale-icon-navigation-right
              class="t-page-breadcrumbs--seperator"
              size="8"
              accessibility-title="right"
            />
          </slot>
        </span>

        <router-link
          v-if="breadcrumb.routeName?.length"
          :to="{
            name: breadcrumb.routeName ? breadcrumb.routeName : '',
            params: breadcrumb.params
          }"
          class="t-page-breadcrumbs--link"
        >
          {{ breadcrumb.translationKey ? t(breadcrumb.translationKey) : breadcrumb.title }}
        </router-link>
        <span v-else class="t-page-breadcrumbs--link">
          {{ breadcrumb.translationKey ? t(breadcrumb.translationKey) : breadcrumb.title }}
        </span>
      </li>
    </ol>
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch } from "vue"
import { useI18n } from "vue-i18n"
import type { RouteParamsRaw } from "vue-router"

const { t } = useI18n()

interface IntBreadcrumb {
  routeName?: string
  title?: string
  translationKey?: string | ""
  params?: RouteParamsRaw | undefined
}

interface Props {
  currentRouteBreadcrumbs: IntBreadcrumb[]
}

interface IntCurrentBreadcrumbsState {
  breadcrumb: IntBreadcrumb[]
}

const currentBreadcrumb: IntCurrentBreadcrumbsState = reactive({
  breadcrumb: []
})

const props = defineProps<Props>()

watch(
  props,
  (currentalue) => {
    currentBreadcrumb.breadcrumb = [...currentalue.currentRouteBreadcrumbs]
  },
  { immediate: true, deep: true }
)
</script>
<style lang="scss" scoped>
.t-page-breadcrumbs {
  --font-size-list-item: calc(var(--scl-spacing-12) + 2px);
  --font-weight-list-item: var(--telekom-typography-font-weight-regular);
  --color-current: var(--telekom-color-text-and-icon-standard);
  --color-separator: var(--telekom-color-text-and-icon-additional);

  --spacing-y-item: var(--telekom-spacing-unit-x1);
  --spacing-x-item: var(--telekom-spacing-unit-x2);

  --color-link: var(--telekom-color-text-and-icon-additional);
  --color-link-hover: var(--telekom-color-text-and-icon-primary-hovered);
  --color-link-active: var(--telekom-color-text-and-icon-primary-pressed);
  --font-weight-list-item-hover: var(--telekom-typography-font-weight-bold);
}
.t-page-breadcrumbs {
  ol {
    list-style: none;
    padding: 0;
    display: flex;
  }

  &--item {
    font-size: var(--font-size-list-item);
    color: var(--color-current);
    font-weight: var(--font-weight-list-item);

    &:first-child {
      padding-left: 0;

      .t-page-breadcrumbs--link {
        padding-left: 0;
      }
    }

    &:hover {
      .t-page-breadcrumbs--link {
        color: var(--color-link-hover);
        text-decoration: none;
      }
    }

    &:last-child {
      font-weight: var(--font-weight-list-item-hover);

      &--link {
        font-weight: inherit;
      }
    }
  }

  &--link {
    padding: var(--spacing-y-item) var(--spacing-x-item);
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    text-decoration: none;
  }

  &--seperator {
    color: var(--color-separator);
  }
}
</style>
